import img1 from "../assets/img/team/Teresareyes.jpg"
import img2 from "../assets/img/team/Alejandramunoz.jpg"
import img3 from "../assets/img/team/Ruthrendon.jpg"
import img4 from "../assets/img/team/Danielhernandez.jpg"
import img5 from "../assets/img/team/Luisreyes.jpg"
import img6 from "../assets/img/team/Dianalopez.jpg"
import img7 from "../assets/img/team/Ivanlara.jpg"
import img8 from "../assets/img/team/Rodrigotellez.jpg"

export default function Team() {
    return (
      <div className="px-4 py-16 mx-auto w-9/12 sm:max-w-xl md:max-w-full lg:max-w-screen-xl md:px-24 lg:px-8 lg:py-20">
        <h1 className="text-4xl font-bold mb-8">
            Nuestro Equipo
        </h1>
        <div className="grid sm:grid-cols-4 gap-10 lg:grid-cols-4">
            <div className="relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
              <img
                className="object-cover w-full md:h-64 xl:h-80"
                src={img1}
                alt="Person"
              />
              <div className="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
                <p className="mb-1 text-lg font-bold text-gray-100">Teresa Reyes</p>
                <p className="mb-4 text-xs text-gray-100">Directora ProMedic</p>
                <p className="mb-4 text-xs tracking-wide text-gray-400">Facilidad para construir y desarrollar equipos de trabajo.
                <br />
                Altamente enfocada en resultados y alcances presupuéstales, así como en el desarrollo personal de los colaboradores a mi cargo.</p>
              </div>
            </div>
            <div className="relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
              <img
                className="object-cover w-full md:h-64 xl:h-80"
                src={img2}
                alt="Person"
              />
              <div className="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
                <p className="mb-1 text-lg font-bold text-gray-100">Alejandra Muñoz</p>
                <p className="mb-4 text-xs text-gray-100">Gerente Salud</p>
                <p className="mb-4 text-xs tracking-wide text-gray-400">Asesorar a las organizaciones en diseño e implementación de prototipos de salud y con modelo de mejora continua que permita medir, evaluar, corregir y dar seguimiento al desempeño del cuerpo médico.
                <br />
                Impulsar la formación técnica y desarrollo personal de los miembros valiosos del equipo de salud a través de capacitación.</p>
              </div>
            </div>
            <div className="relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
              <img
                className="object-cover w-full md:h-64 xl:h-80"
                src={img3}
                alt="Person"
              />
              <div className="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
                <p className="mb-1 text-lg font-bold text-gray-100">Ruth Rendón</p>
                <p className="mb-4 text-xs text-gray-100">Gerente Logística y Servicio</p>
                <p className="mb-4 text-xs tracking-wide text-gray-400">Visitar y atender personalmente a nuestros clientes dando seguimiento a sus necesidades. Garantizar el servicio al cliente, coordinar y organizar el área de logística. Manejo de personal de los Centros de Atención Médica y de Proyectos.
                <br />
                Optimizar los recursos de la empresa eficientizando la operación y controlando los gastos.</p>
              </div>
            </div>
            <div className="relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
              <img
                className="object-cover w-full md:h-64 xl:h-80"
                src={img4}
                alt="Person"
              />
              <div className="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
                <p className="mb-1 text-lg font-bold text-gray-100">Daniel Hernández</p>
                <p className="mb-4 text-xs text-gray-100">Gerente Innovación</p>
                <p className="mb-4 text-xs tracking-wide text-gray-400">Responsable de Innovación y Mejora Continua, abarcando las áreas de tecnología, procesos, calidad y comercial, así como las interacciones de las mismas con el resto los departamentos, enfocado en mejorar el rendimiento de la organización y la experiencia del cliente.</p>
              </div>
            </div>
            <div className="relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
              <img
                className="object-cover w-full md:h-64 xl:h-80"
                src={img5}
                alt="Person"
              />
              <div className="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
                <p className="mb-1 text-lg font-bold text-gray-100">Luis Reyes</p>
                <p className="mb-4 text-xs text-gray-100">Gerente RRH</p>
                <p className="mb-4 text-xs tracking-wide text-gray-400">Responsable de los procesos de recursos humanos, atracción de talento, retención de personal, administración del recurso humano, capacitación, actividades sociales y de recración de la empresa, responsable de asuntos en materia laboral, sueldos y compensaciones del personal, gestión y desarrollo del talento.</p>
              </div>
            </div>
            <div className="relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
              <img
                className="object-cover w-full md:h-64 xl:h-80"
                src={img6}
                alt="Person"
              />
              <div className="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
                <p className="mb-1 text-lg font-bold text-gray-100">Diana López</p>
                <p className="mb-4 text-xs text-gray-100">Directora Administración</p>
                <p className="mb-4 text-xs tracking-wide text-gray-400">Dirigir, organizar y controlar las áreas administrativas contables y financieras.
                <br />
                Gestionar de manera eficaz los recursos monetarios de la empresa para contar con la liquidez suficiente para hacer frente a los compromisos generados en tiempo y forma.</p>
              </div>
            </div>
            <div className="relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
              <img
                className="object-cover w-full md:h-64 xl:h-80"
                src={img7}
                alt="Person"
              />
              <div className="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
                <p className="mb-1 text-lg font-bold text-gray-100">Iván de Lara</p>
                <p className="mb-4 text-xs text-gray-100">Gerente Administración</p>
                <p className="mb-4 text-xs tracking-wide text-gray-400">Responsable del área de Administración y Finanzas,  que tiene la responsabilidad del control y manejo de los recursos de la empresa, con enfoque de servicio hacia nuestros  clientes externos e internos.</p>
              </div>
            </div>
            <div className="relative overflow-hidden transition duration-300 transform rounded shadow-lg lg:hover:-translate-y-2 hover:shadow-2xl">
              <img
                className="object-cover w-full md:h-64 xl:h-80"
                src={img8}
                alt="Person"
              />
              <div className="absolute inset-0 flex flex-col justify-center px-5 py-4 text-center transition-opacity duration-300 bg-black bg-opacity-75 opacity-0 hover:opacity-100">
                <p className="mb-1 text-lg font-bold text-gray-100">Rodrigo Téllez</p>
                <p className="mb-4 text-xs text-gray-100">Jefe de Marketing</p>
                <p className="mb-4 text-xs tracking-wide text-gray-400">Desarrollar e implementar estrategias y campañas de promoción comercial acorde a las necesidades de nuestros clientes, con el fin de generar nuestro posicionamiento como lideres en el área de salud ocupacional en el sector empresarial e industrial de México.</p>
              </div>
            </div>
        </div>
      </div>
    );
  };